import { gql } from "@apollo/client";

const QUESTIONNAIRE_OPTION_FIELDS = gql`
  fragment QuestionnaireOptionFields on QuestionnaireOption {
    id
    label
    order
    visibility
    visibilityRules {
      id
      sourceQuestionId
      allowedValues
    }
  }
`;

const QUESTIONNAIRE_QUESTION_FIELDS = gql`
  fragment QuestionnaireQuestionFields on QuestionnaireQuestion {
    id
    title
    description
    required
    type
    scope
    order
    questionnairePageOrder
    visible
    options {
      ...QuestionnaireOptionFields
    }
    visibilityRules {
      id
      sourceQuestionId
      allowedValues
    }
  }
  ${QUESTIONNAIRE_OPTION_FIELDS}
`;

const QUESTIONNAIRE_PAGE_FIELDS = gql`
  fragment QuestionnairePageFields on QuestionnairePage {
    id
    title
    order
    questions {
      ...QuestionnaireQuestionFields
    }
  }
  ${QUESTIONNAIRE_QUESTION_FIELDS}
`;

export const CREATE_QUESTIONNAIRE_MODULE = gql`
  mutation CreateQuestionnaireModule($eventId: ID!) {
    createQuestionnaireModule(eventId: $eventId) {
      id
      moduleStatus
      pages {
        ...QuestionnairePageFields
      }
    }
  }
  ${QUESTIONNAIRE_PAGE_FIELDS}
`;

export const DELETE_QUESTIONNAIRE_MODULE = gql`
  mutation DeleteQuestionnaireModule($eventId: ID!) {
    deleteQuestionnaireModule(eventId: $eventId)
  }
`;

export const CREATE_QUESTIONNAIRE_PAGE = gql`
  mutation CreateQuestionnairePage($questionnaireId: ID!, $title: String!) {
    createQuestionnairePage(questionnaireId: $questionnaireId, title: $title) {
      ...QuestionnairePageFields
    }
  }
  ${QUESTIONNAIRE_PAGE_FIELDS}
`;

export const UPDATE_QUESTIONNAIRE_PAGE = gql`
  mutation UpdateQuestionnairePage($pageId: ID!, $title: String!) {
    updateQuestionnairePage(pageId: $pageId, title: $title) {
      id
      title
      order
    }
  }
`;

export const DELETE_QUESTIONNAIRE_PAGE = gql`
  mutation DeleteQuestionnairePage($pageId: ID!) {
    deleteQuestionnairePage(pageId: $pageId)
  }
`;

export const REORDER_QUESTIONNAIRE_PAGES = gql`
  mutation ReorderQuestionnairePages($questionnaireId: ID!, $orderedPageIds: [ID!]!) {
    reorderQuestionnairePages(questionnaireId: $questionnaireId, orderedPageIds: $orderedPageIds) {
      ...QuestionnairePageFields
    }
  }
  ${QUESTIONNAIRE_PAGE_FIELDS}
`;

export const CREATE_QUESTIONNAIRE_QUESTION = gql`
  mutation CreateQuestionnaireQuestion(
    $questionnairePageId: ID!
    $title: String!
    $description: String
    $required: Boolean!
    $type: QuestionType!
    $scope: QuestionScope
    $options: [QuestionnaireOptionInput!]
  ) {
    createQuestionnaireQuestion(
      questionnairePageId: $questionnairePageId
      title: $title
      description: $description
      required: $required
      type: $type
      scope: $scope
      options: $options
    ) {
      ...QuestionnaireQuestionFields
    }
  }
  ${QUESTIONNAIRE_QUESTION_FIELDS}
`;

export const UPDATE_QUESTIONNAIRE_QUESTION = gql`
  mutation UpdateQuestionnaireQuestion(
    $questionId: ID!
    $title: String!
    $description: String
    $required: Boolean!
    $type: QuestionType!
    $scope: QuestionScope
    $options: [QuestionnaireOptionInput!]
  ) {
    updateQuestionnaireQuestion(
      questionId: $questionId
      title: $title
      description: $description
      required: $required
      type: $type
      scope: $scope
      options: $options
    ) {
      ...QuestionnaireQuestionFields
    }
  }
  ${QUESTIONNAIRE_QUESTION_FIELDS}
`;

export const DELETE_QUESTIONNAIRE_QUESTION = gql`
  mutation DeleteQuestionnaireQuestion($questionId: ID!) {
    deleteQuestionnaireQuestion(questionId: $questionId)
  }
`;

export const TOGGLE_QUESTIONNAIRE_QUESTION_VISIBILITY = gql`
  mutation ToggleQuestionnaireQuestionVisibility($questionId: ID!, $visible: Boolean!) {
    toggleQuestionnaireQuestionVisibility(questionId: $questionId, visible: $visible) {
      id
      visible
    }
  }
`;

export const REORDER_QUESTIONNAIRE_QUESTIONS = gql`
  mutation ReorderQuestionnaireQuestions($questionnairePageId: ID!, $orderedQuestionIds: [ID!]!) {
    reorderQuestionnaireQuestions(
      questionnairePageId: $questionnairePageId
      orderedQuestionIds: $orderedQuestionIds
    ) {
      ...QuestionnaireQuestionFields
    }
  }
  ${QUESTIONNAIRE_QUESTION_FIELDS}
`;

export const MOVE_QUESTION_TO_PAGE = gql`
  mutation MoveQuestionToPage($questionId: ID!, $targetPageId: ID!) {
    moveQuestionToPage(questionId: $questionId, targetPageId: $targetPageId) {
      ...QuestionnaireQuestionFields
    }
  }
  ${QUESTIONNAIRE_QUESTION_FIELDS}
`;

export const CREATE_QUESTIONNAIRE_VISIBILITY_RULE = gql`
  mutation CreateQuestionnaireVisibilityRule($input: QuestionnaireVisibilityRuleInput!) {
    createQuestionnaireVisibilityRule(input: $input) {
      id
      sourceQuestionId
      allowedValues
    }
  }
`;

export const DELETE_QUESTIONNAIRE_VISIBILITY_RULE = gql`
  mutation DeleteQuestionnaireVisibilityRule($ruleId: ID!) {
    deleteQuestionnaireVisibilityRule(ruleId: $ruleId)
  }
`;

export const ANSWER_QUESTIONNAIRE = gql`
  mutation AnswerQuestionnaire(
    $orderAnswers: [QuestionnaireAnswerInput!]
    $itemAnswers: [QuestionnaireCartItemAnswersInput!]
  ) {
    answerQuestionnaire(orderAnswers: $orderAnswers, itemAnswers: $itemAnswers)
  }
`;